"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDataEpoqBuyCart = void 0;
const getDataEpoqObject_1 = require("./getDataEpoqObject");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackDataEpoqBuyCart(order, tenant) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        DataEpoqBuyCart: (0, getDataEpoqObject_1.getDataEpoqObject)(order, tenant),
    });
}
exports.trackDataEpoqBuyCart = trackDataEpoqBuyCart;
//# sourceMappingURL=trackDataEpoqBuyCart.js.map